import {
  Box,
  Flex,
  Link,
  Modal,
  theme,
  Typography,
} from '@fe-toolkit/web-components/ssr'

import content from '@/content/content'

type CanIkeepMyNumberModalProps = {
  display: boolean
  setDisplay: (display: boolean) => void
}

const CanIkeepMyNumberModal = ({
  display,
  setDisplay,
}: CanIkeepMyNumberModalProps) => {
  const { canIkeepMyNumberModal } = content
  return (
    <Modal
      closeModal={() => setDisplay(false)}
      disableScrolling={true}
      display={display}
      modalBackgroundColour="wildSand"
      setDisplay={setDisplay}
      title={canIkeepMyNumberModal.title}
    >
      <Flex flexDirection="column" gap={theme.spacing.tiny}>
        <Typography as={'p'} variant={'speak'}>
          {canIkeepMyNumberModal.description}
        </Typography>
        <Typography as={'p'} variant={'speak'}>
          {`${canIkeepMyNumberModal.steps1Part1}`}
          <Typography variant={'speakUp'}>
            {canIkeepMyNumberModal.steps1Part2}
          </Typography>
          {`${canIkeepMyNumberModal.steps1Part3}`}
          <Typography variant={'speakUp'}>
            {canIkeepMyNumberModal.steps1Part4}
          </Typography>
          {`${canIkeepMyNumberModal.steps1Part5}`}
        </Typography>
        <Typography as={'p'} variant={'speak'}>
          {canIkeepMyNumberModal.steps2}
        </Typography>
        <Typography as={'p'} variant={'speak'}>
          {canIkeepMyNumberModal.steps3Part1}
          <Typography variant={'speakUp'}>
            {canIkeepMyNumberModal.steps3Part2}
          </Typography>
          <Typography variant={'speak'}>
            {canIkeepMyNumberModal.steps3Part3}
          </Typography>
          <Typography variant={'speakUp'}>
            {canIkeepMyNumberModal.steps3Part4}
          </Typography>
          <Typography variant={'speak'}>
            {canIkeepMyNumberModal.steps3Part5}
          </Typography>
        </Typography>
        <Typography as={'p'} variant={'speak'}>
          {canIkeepMyNumberModal.steps4}
        </Typography>
        <Typography as={'p'} variant={'speak'}>
          {canIkeepMyNumberModal.steps5}
        </Typography>
        <Box marginTop={theme.spacing.large} textAlign="center">
          <Link as={'button'} onClick={() => setDisplay(false)}>
            {content.modalCloseLinkLabel}
          </Link>
        </Box>
      </Flex>
    </Modal>
  )
}

export default CanIkeepMyNumberModal
